import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import type { CheckboxProps } from 'antd';
import clsx from 'clsx';

export const Checkbox = ({ className, ...props }: CheckboxProps) => (
  <AntCheckbox {...props} className={clsx('wk-checkbox', className)} />
);

Checkbox.Group = AntCheckbox.Group;
